import axios from "axios";
import { useQuery } from "react-query";
import { ResolvedReview } from "resolvers/data/trustpilotResolver";
import axiosOnSuccessEvent from "utils/axiosOnSuccessEvent";

interface Reviews {
    overview: {
        totalReviews: number;
        rating: number;
    };
    reviews: ResolvedReview[];
}

const useReviews = () => {
    const fetchReviews = async () => {
        const response = await axios.get<Reviews>("/api/testimonials");
        axiosOnSuccessEvent(response);
        return response.data;
    };

    return useQuery("reviews", fetchReviews, {
        refetchOnWindowFocus: false,
        retry: 3,
        retryDelay: (attemptIndex, error) => {
            return Math.pow(2, attemptIndex) * 200;
        },
    });
};

export default useReviews;
